export function buildQueryParams<
	T extends Record<string, string | number | undefined | null>,
	K extends Record<string, string>
>(params: T, sortByEnum?: K) {
	const paramsList = Object.entries(params).map(([key, value]) => {
		const typedKey = key as keyof T;
		if (typedKey === 'sortBy' && !!sortByEnum) {
			const typedValue = value as keyof K;
			return value ? `&${key}=${sortByEnum[typedValue]}` : '';
		}
		return value ? `&${key}=${value}` : '';
	});
	const queryParams = paramsList.join('');
	return queryParams.charAt(0) === '&' ? queryParams.substring(1) : queryParams;
}
